import React from 'react';
import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

import PostItem from './PostItem';

export interface Props {
  posts: Post[];
  selectedIndex: number;
  overlay?: boolean;
  imageHeight: number;
  sideBySide?: boolean;
  hideDetail?: boolean;
  onPageClick: (index: number) => void;
  type: postTypes;
}

interface PaginatorProps {
  selectedIndex: number;
  onClick: (index: number) => void;
  length: number;
}

const usePaginatorStyles = makeStyles<Theme>((theme: Theme) => ({
  circle: {
    border: '2px solid #FFF',
    borderRadius: 8,
    cursor: 'pointer',
    height: 16,
    width: 16,
  },
  filled: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
  },
  paginator: {
    display: 'flex',
    justifyContent: 'center',
    margin: '16px 0px 0px',
    '& > *': {
      margin: '0px 4px',
    },
  },
}));

const PostSlider: React.FC<Props> = ({
  posts,
  overlay,
  imageHeight,
  sideBySide,
  hideDetail,
  selectedIndex,
  onPageClick,
  type,
}) => {
  return (
    <>
      <PostItem
        post={posts[selectedIndex]}
        overlay={overlay}
        imageHeight={imageHeight}
        sideBySide={sideBySide}
        hideDetail={hideDetail}
        type={type}
        titleSize='h6'
      />
      <Paginator
        selectedIndex={selectedIndex}
        onClick={onPageClick}
        length={posts.length}
      />
    </>
  );
};

const Paginator: React.FC<PaginatorProps> = ({
  selectedIndex,
  onClick,
  length,
}) => {
  const { circle, filled, paginator } = usePaginatorStyles();
  return (
    <div className={paginator}>
      {Array.apply(null, Array(length)).map((_, index) => (
        <div
          key={index}
          className={clsx({
            [circle]: true,
            [filled]: index === selectedIndex,
          })}
          onClick={() => onClick(index)}
        />
      ))}
    </div>
  );
};

export default PostSlider;
